import { Component, Input } from "@angular/core";

import { ApiService } from "src/app/api.service";
import { APIResults, AssemblyConfig } from "src/app/sharedinterfaces";

@Component({
  selector: "app-health-split-fleet",
  templateUrl: "./health-split-fleet.component.html",
  styleUrls: ["./health-split-fleet.component.scss"]
})
export class HealthSplitFleetComponent {
	@Input()
	fleet: APIResults.Fleet;

	constructor(public api: ApiService) { }

	get allFixed(): boolean {
		if (!this.fleet.assets) return false;
		return this.fleet.assets.every(asset => asset.is_fixed);
	}
	
	get rtbHealth(): number {
		return this.fleet.rtbhealth;
	}

	get fdmHealth(): number {
		let himax = this.fleet.assets.some(asset => asset.exceedancecount > 0) ? AssemblyConfig.HumsHiThreshold.Warning : 0;
		himax = Math.max(himax, this.fleet.assets.some(asset => asset.severeexceedancecount > 0) ? AssemblyConfig.HumsHiThreshold.Alarm : 0);
		return himax;
	}

	get mdHealth(): number {
		const obcuHealth = 0; // TODO: Temporarily turning off obcu health alerts // this.fleet.latest_obcu_failures > 0 ? AssemblyConfig.HumsHiThreshold.Alarm : 0;
		return Math.max(this.fleet.mdmax, obcuHealth);
	}

	get overallHealth(): number {
		return Math.max(this.rtbHealth, this.fdmHealth, this.mdHealth);
	}

	get healthText(): string {
		if (this.overallHealth >= AssemblyConfig.HumsHiThreshold.Warning) {
			return "Attention needed";
		} else {
			return "Normal Conditions";
		}
	}

	backgroundClass(health: number): string {
		if (health >= AssemblyConfig.HumsHiThreshold.Alarm) {
			return "status-error-bg"
		} else if (health >= AssemblyConfig.HumsHiThreshold.Warning) {
			return "status-warning-bg"
		} else {
			return "status-ok-bg";
		}
	}

	get iconClass(): string {
		if (this.overallHealth >= AssemblyConfig.HumsHiThreshold.Warning) {
			return "icon-attention-alt"
		} else {
			return "icon-ok";
		}
	}
}
